import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    getFileUploadUrl,
    scanUserAttachment,
    getFileViewUrl
} from 'src/api/apiCaller';
import {
    getMessageAttachmentUploadUrl,
    getMessageAttachmentViewUrl,
    scanMessageAttachment
} from 'src/api/chat';
import { FileUploadUrlRequest, FileRequest } from 'src/types/proof-of-work';
export const SLICE_NAME = 'proof-of-work';

export const ACTION_TYPES = {
    GET_FILE_UPLOAD_URL: `${SLICE_NAME}/getFileUploadUrl`,
    GET_FILE_VIEW_URL: `${SLICE_NAME}/getFileViewUrl`,
    SCAN_FILE: `${SLICE_NAME}/scanFile`
};

export const getUploadUrl = createAsyncThunk(
    ACTION_TYPES.GET_FILE_UPLOAD_URL,
    async (options: FileUploadUrlRequest, { rejectWithValue }) => {
        try {
            const response = await getFileUploadUrl(options);
            const uploadDetails = response.data;
            return { url: uploadDetails.url, fileId: uploadDetails.fileId };
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getViewUrl = createAsyncThunk(
    ACTION_TYPES.GET_FILE_VIEW_URL,
    async (options: FileRequest, { rejectWithValue }) => {
        try {
            const response = await getFileViewUrl(options);
            return response.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const scanFile = createAsyncThunk(
    ACTION_TYPES.SCAN_FILE,
    async (options: FileRequest, { rejectWithValue }) => {
        try {
            const response = await scanUserAttachment(options);
            return response.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getMessageUploadUrl = createAsyncThunk(
    'attachment/getMessageUploadUrl',
    async (
        options: { fileName: string; fileType: string; conversationId: number },
        { rejectWithValue }
    ) => {
        try {
            const response = await getMessageAttachmentUploadUrl(
                options.fileName,
                options.fileType,
                options.conversationId
            );
            return {
                url: response.data.url,
                fileId: response.data.attachmentId
            };
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getMessageViewUrl = createAsyncThunk(
    'attachment/getMessageViewUrl',
    async (options: { attachmentId: number }, { rejectWithValue }) => {
        try {
            const response = await getMessageAttachmentViewUrl(
                options.attachmentId
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const scanMessageFile = createAsyncThunk(
    'attachment/scanMessageFile',
    async (options: { attachmentId: number }, { rejectWithValue }) => {
        try {
            const response = await scanMessageAttachment(options.attachmentId);
            return response.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
